// FLAGS: none
// The millisecond staleTime constants every hook here shares; `consultStaleTime` is also the global default in App.tsx.
export const hours = (amount: number) => amount * 1000 * 60 * 60;
export const minutes = (amount: number) => amount * 1000 * 60;

export const oneHour = hours(1);
export const fifteenMinutes = minutes(15);
export const fiveMinutes = minutes(5);
export const shortestStaleTime = minutes(5);
export const LongerStaleTime = minutes(60);
export const consultStaleTime = minutes(20);
